import { useLazyQuery, gql } from "@apollo/client"

const SEARCH_LIMIT = 20

const SEARCH_FIELDS = `
    id
    title
    type
    date
    score
    organisation
    createdAt
    updatedAt
`

const SEARCH_QUERY = gql`query SearchAreas($limit: Int!, $searchText: String!, $location: ID!) {
  searchAreas(limit: $limit, searchText: $searchText, location: $location) {
    keywords
    jobs {
      total
      items {
        ${SEARCH_FIELDS}
      }
    }
    knowledge {
      total
      items {
        ${SEARCH_FIELDS}
      }
    }
    posts {
      total
      items {
        ${SEARCH_FIELDS}
      }
    }
  } 
}`

const useLazyQuerySearch = (options) => {
  const [load, result] = useLazyQuery(SEARCH_QUERY, {
    variables: {
      limit: SEARCH_LIMIT,
    },
    ...options,
  })

  return [load, result]
}

export { useLazyQuerySearch }
